import React, { useEffect } from 'react'
import MyMap from '../../Map/Views/MyMap'
import './Footer.css'

export default function Footer() {
    
    let isNan = (val) => { return val != val}

    let onSubmitLocation = (e) => {
        e.preventDefault()
        
        let inputValue = e.target.coord.value
        if(inputValue.includes('/')){
            let lon = parseFloat(inputValue.split('/')[0])
            let lat = parseFloat(inputValue.split('/')[1])
            if(isNan(lon) || isNan(lat)){
                alert(`Konum Bilgisi '39.96 / 40.87' Formatında Yazılmalıdır. `)
                return
            } else {
                MyMap.getView().setCenter([lon,lat])
                MyMap.getView().setZoom(16)
            }

        } else {
            alert(`Konum Bilgisi '39.96 / 40.87' Formatında Yazılmalıdır. `)
        }
    }
    
    const onMapPointerChange = (e) => {
        let lon = e.coordinate[0].toFixed(4)
        let lat = e.coordinate[1].toFixed(4)
        document.getElementById('coord').value = lon+' / '+lat
    }

    useEffect(() => {
        let isMounted = true
        if(isMounted){
            MyMap.on('pointermove',onMapPointerChange)
        }
        return () => {
            MyMap.un('pointermove',onMapPointerChange)
        }
    }, [])
    
    return (
    <>
        <div className="footerStyle">
            <form onSubmit={(e)=> onSubmitLocation(e)} style={{width:'100%'}}>
                <input id='coord' type='text' style={{fontSize:'0.55rem'}} className='form-control form-control-sm locationForm'></input>
            </form>
        </div>
    </>
    )
    
}
